import type { StorageAdapter } from './StorageAdapter';
import { LocalStorageAdapter } from './LocalStorageAdapter';
import { VkStorageAdapter } from './VkStorageAdapter';
import type { AppRuntimeKind } from '../runtime/detectRuntime';
import { initVkMiniApp } from '../vk/initVkMiniApp';

/**
 * Выбор адаптера по среде; при ошибке инициализации VK — fallback на localStorage (tech-spec §16.2).
 */
export async function createStorageAdapterWithFallback(
  kind: AppRuntimeKind,
): Promise<StorageAdapter> {
  if (kind !== 'vk_mini_app') {
    return new LocalStorageAdapter();
  }
  try {
    await initVkMiniApp();
    return new VkStorageAdapter();
  } catch (e) {
    console.warn('[infra] VK init failed, falling back to localStorage', e);
    return new LocalStorageAdapter();
  }
}
